import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';

import { contributionOptions } from '@/module/Nomen/Contribution/model/ContributionModel';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

type ContributionSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function ContributionSelectControl<T extends FieldValues>(props: ContributionSelectControlProps<T>) {
  const { data, isLoading, isError } = useQuery(contributionOptions.getAll());

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={data ?? []}
      {...props}
    />
  );
}
